export default function COUNTIF() {
  return (
    <div className="p-4">
      <h1>COUNTIF</h1>
    </div>
  );
}
